import {pick} from "../../utils/utils";
import {Sizes} from "../../core/constants/sizes";
import {ValueOf} from "../../types/interfaces";

export const LinkSizes = pick(Sizes, ['_S', '_M', '_L'])
export type LinkSizesType = `${ValueOf<typeof LinkSizes>}`

export const LinkClass = {
	root: 'gov-link',
	external: 'gov-link--external',
}
